import { Component, OnInit } from '@angular/core';
import {ICellRendererAngularComp} from "ag-grid-angular";
import {ICellRendererParams} from "ag-grid-community";
import {HttpService} from "../../../services/http.service";
import {environment} from "../../../../environments/environment";
import {GridService} from "../../../services/grid.service";

@Component({
  selector: 'app-ai-category-cell',
  templateUrl: './ai-category-cell.component.html',
  styleUrls: ['./ai-category-cell.component.scss']
})
export class AiCategoryCellComponent implements ICellRendererAngularComp, OnInit {
  private params!: ICellRendererParams;
  public value: any = '';
  public levels: string = '';
  constructor(
    private httpService: HttpService,
    private gridService: GridService
  ) { }

  ngOnInit(): void {
    this.gridService.aiTreeSelectLevel.asObservable().subscribe(res => {
      if (res) {
        this.levels = res;
      }
    });
  }
  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.value = this.params.value;

    this.gridService.aiTreeChangeFilter.subscribe(res => {
      if (res && res.length > 0) {
        const searchText = res;
        const startIndex = this.params.value.toLowerCase().indexOf(searchText.toLowerCase());
        const endIndex = startIndex + searchText.length;

        if (startIndex !== -1) {
          const start = this.params.value.slice(0, startIndex);
          const end = this.params.value.slice(startIndex + searchText.length);
          const text = this.params.value.slice(startIndex, endIndex);
          this.value = `${start}<span class="ai-cat-search-text">${text}</span>${end}`;
        } else {
          this.value = this.params.value;
        }
      }
    });


  }

  refresh(params: ICellRendererParams): boolean {
    return true;
  }

  public reRunGptNestedCat(): void {
    if (window.confirm('Are you sure?')) {
      this.httpService.post(environment.API_PATH + '/ai/reRunAllNestedTreeItemsOnGpt', {
        field: this.value,
        levels: this.levels
      }).subscribe(res => {
        // console.log('⭕️', res);
        // this.gridService.aiTreeGridEvent.next('rename');
      });
    }
  }

  public reRunGpt(): void {
    if (window.confirm('Are you sure?')) {
      this.httpService.post(environment.API_PATH + '/ai/reRunTreeItemsOnGpt', {
        field: this.value,
        levels: this.levels
      }).subscribe(res => {
        // console.log('⭕️', res);
        // this.gridService.aiTreeGridEvent.next('rename');
      });
    }
  }

  public remove(): void {
    setTimeout(() => {
      if (window.confirm('Are you sure?')) {
        this.httpService.post(environment.API_PATH + '/ai/treeActions', {
          type: 'remove',
          new_name: prompt,
          field: this.value,
          levels: this.levels
        }).subscribe(res => {
          // console.log('⭕️', res);
          // this.gridService.aiTreeGridEvent.next('remove');
        });
      }
    }, 50);
  }

  public megaRename(): void {
    setTimeout(() => {
      const prompt = window.prompt('Mega Rename', this.levels);
      if (prompt && prompt.length) {
        this.httpService.post(environment.API_PATH + '/ai/treeActions', {
          type: 'mega_rename',
          new_path: prompt,
          field: this.value.replace(/<[^>]+>/g, ''),
          levels: this.levels
        }).subscribe(res => {
          // console.log('⭕️', res);
          // this.gridService.aiTreeGridEvent.next('rename');
        });
      }
    }, 100);
  }

  public rename(): void {
    setTimeout(() => {
      const prompt = window.prompt('Rename', this.value.replace(/<[^>]+>/g, ''));
      if (prompt && prompt.length) {
        this.httpService.post(environment.API_PATH + '/ai/treeActions', {
          type: 'rename',
          new_name: prompt,
          field: this.value,
          levels: this.levels
        }).subscribe(res => {
          // console.log('⭕️', res);
          // this.gridService.aiTreeGridEvent.next('rename');
        });
      }
    }, 100);
  }
  public info() {
    setTimeout(() => {
      // console.log('AiCategoryCellComponent', this.levels);
      this.httpService.post(environment.API_PATH + '/ai/treeActions', {
        field: this.value,
        levels: this.levels
      }).subscribe(res => {
        // console.log('⭕️', res);
      });
    }, 100);
  }

}
